import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

const InfoBox = ({ children }) => {
  return (
    <div className="flex items-start gap-2 rounded-lg border border-solid border-neutral-200 bg-neutral-50 p-3">
      <Icon icon="money-transaction-mono" size={16} />
      <div className="flex flex-col gap-2">
        <Typography variant="p" size="small" className="!block min-w-0" parentClassName="min-w-0">
          {children}
        </Typography>
      </div>
    </div>
  );
};

export default InfoBox;
